import React from 'react';

const PRCard = ({ record, exercise }) => {
  const typeLabels = {
    max_weight: 'Peso Máximo',
    max_reps: 'Máximas Repeticiones',
    max_volume: 'Volumen Máximo',
    max_1rm: '1RM Estimado'
  };

  const typeColors = {
    max_weight: 'from-purple-500 to-purple-700',
    max_reps: 'from-blue-500 to-blue-700',
    max_volume: 'from-green-500 to-green-700',
    max_1rm: 'from-orange-500 to-orange-700'
  };

  return (
    <div className={`bg-gradient-to-br ${typeColors[record.record_type]} rounded-lg p-4 text-white shadow-lg`}>
      <div className="flex items-start justify-between mb-2">
        <div>
          <h3 className="text-lg font-semibold">{exercise?.name || 'Ejercicio'}</h3>
          <p className="text-sm opacity-90">{typeLabels[record.record_type]}</p>
        </div>
        <span className="text-3xl">🏆</span>
      </div>
      
      <div className="mt-3">
        <div className="text-3xl font-bold">
          {record.record_type === 'max_weight' && `${record.value} kg`}
          {record.record_type === 'max_reps' && `${record.value} reps`}
          {record.record_type === 'max_volume' && `${record.value} kg`}
          {record.record_type === 'max_1rm' && `${record.value} kg`}
        </div>
        
        {record.reps && record.weight && (
          <p className="text-sm mt-1 opacity-90">
            {record.weight} kg × {record.reps} reps
          </p>
        )}
        
        <p className="text-xs mt-2 opacity-75">
          {new Date(record.achieved_date).toLocaleDateString('es-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
        </p>
      </div>
    </div>
  );
};

export default PRCard;
